import { Link } from "react-router-dom";
import styled from "styled-components";

export const FormContainer = styled.div`
  display: flex;
  background: #000;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  color: #fff;
  background: radial-gradient(
    circle farthest-corner at 18.5% 28.5%,
    #203a43 0,
    #0f1b27 91%
  );
`;

export const BackButton = styled(Link)`
  text-decoration: none;
  color: #fff;
  background-color: #000;
  padding: 14px 48px;
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  margin: 20px;
  white-space: nowrap;
  transition: all 0.2s ease-in-out;
`;

export const FormWrapper = styled.div`
  padding: 30px;
  margin-top: 30px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background-image: linear-gradient(
    -25deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
`;

export const FormGroup = styled.div`
  color: #fff;
  display: block;
  width: 300px;
  margin: 30px auto;
`;

export const FormHeading = styled.h1`
  margin: 80px;
  max-width: 80%;
  text-align: center;
`;

export const Label = styled.label`
  margin-bottom: 0.5em;
  color: #fff;
  display: block;
`;

export const Input = styled.input`
  padding: 0.5em;
  border: none;
  border-radius: 3px;
  width: 100%;
  margin-bottom: 0.5em;

  &.requirements {
    height: 100px;
    padding-bottom: 80px;
    padding-top: 8px;
  }
`;

export const FormSubmit = styled.button`
  padding: 10px 22px;
  display: flex;
  border-radius: 50px;
  margin: auto;
  background-color: #ddd;
  border: none;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #010606;
  }
`;

export const Message = styled.label`
  margin-bottom: 0.5em;
  color: black;
  display: block;
`;
